import React from 'react';
import { Badge, Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { chartSeriesColor } from 'Utils/styleTokens';
import TimeSeriesChart from './TimeSeriesChart';
import DiscoveryTooltip from 'DiscoveryTooltip';
import { getDisplayId, uiLabel } from 'Utils';
import 'react-loading-skeleton/dist/skeleton.css'



const fakeData = [
  {
    date: "2024-03-20",
    sensitiveFieldCount: 100,
    searchids: ["dev-sugarcrm_1745806319746"]
  },
  {
    date: "2025-05-12",
    sensitiveFieldCount: 100,
    searchids: ["dev-sugarcrm_1745506085339"]
  },
  
 ]

const getColorArr = (findings) => {
  let colorArrayValue = [];

  if (findings) {
    colorArrayValue = Array.from({ length: findings.length }, (_, i) => chartSeriesColor(i));
  }

  return colorArrayValue;
}

const Insights = (props) => {
  const searchid = props.searchid;
  const findings = props.findings;
  const timeSeriesData = props.timeSeriesData;
  const displayid = getDisplayId(searchid);
  const colorArray = getColorArr(findings);
  
  // Get latest searchid from discovery results over time
  const latestDiscoverySearchid = timeSeriesData && timeSeriesData.length > 0 
    ? timeSeriesData[timeSeriesData.length - 1].searchids[0] 
    : searchid;

  return (
    <div className='mt-3'>
      <h5 className='text-left sg-eyebrow'>{props.title || 'Discovery results over time'}</h5>
      <Card>
        <Card.Body>
          <div className='d-flex text-left'>
            {/* <div className='flex-shrink-0 mr-5'>
              <div className='ls-insight-label'>
                <b>CURRENT RESULTS</b>
              </div>
              <div>
                <Link to={`/results/${searchid}`}>
                  { displayid || searchid }
                </Link>
              </div>
            </div> */}
            {/* { findings && findings.length ? (
              <div className='flex-grow-1'>
                <div className='ls-insight-label'>
                  <b>CURRENT FINDINGS</b>
                </div>
                <div className='d-flex flex-wrap'>
                  { findings.map((finding, i) => {
                    return (
                      <DiscoveryTooltip
                        key={i}
                        placement='top'
      
                        text={`See locations where ${uiLabel( finding.entity)} data was discovered in this data source`}
                      >
                        <Link to={`/results/${searchid}/${finding.entity}`}>
                          <Badge
                            style={{ backgroundColor: colorArray[i], color: '#fff' }}
                            className='mb-1 landscape-badge entity-link'
                          >
                            { uiLabel(finding.entity)}
                          </Badge>
                        </Link>
                      </DiscoveryTooltip>
                    )
                  })}
                </div>
              </div>
            ) : (null)} */}
          </div>
          <Row className='pt-2'>
            <Col>
              <TimeSeriesChart
                searchid={latestDiscoverySearchid}
                // timeSeriesData={fakeData}
                timeSeriesData={timeSeriesData}
                getResultHref={props.getResultHref}
                maskingHint={props.maskingHint}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  )
};

export default Insights;